import { remove } from "../../../../../components/textfield/autocomplete-handler";
import clientPurchaseFullcont from "./clientPurchase-fullcont.html";

const dialog = require('../../../../../components/dialog/dialog')
const fullcontEntity = require('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler = require('../../../../../components/fullcont/fullcont-handler')
const clientPurchaseDt = require('./clientPurchase-dt')
const handler = require('./clientPurchase-fullcont-handler')
const { formCopy } = require('./clientPurchase-fullcont-form')
const { form } = require('./clientPurchase-fullcont-form')
const { clientPurchaseMT } = require('./clientPurchase-fullcont-multitable')
const clientPurchaseMenu = require('./clientPurchase-menu')

// const clientPurchaseMT   = undefined //no MT just add this like undefined

/****************ELEMENTS*****************/
let dest = null;
var htmlFc = {}
var HTMLwasSelected = false

function HTMLselect(detail) {

      fullcontHandler.HTMLselect(
            'clientPurchase', //database table name****
            // 'clientPurchase', //dest entity on js
            dest, //dest entity on js
            'clientPurchase-fullcont',
            clientPurchaseFullcont,
            form,
            formCopy,
            clientPurchaseMT,
            editDialog,
            deleteDialog,
            dtCall,
            htmlFc
      )

      HTMLwasSelected = true

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail) {  //console.log('clientPurchase-dt 5>', clientPurchaseMT)

      // para poder pintar el fc dentro del page correcto "clientActivity"
      if (detail.act === "selectOne") {
            dest = "clientActivity";
      } else {
            // se resetea el "HTMLselect"
            dest = "clientPurchase";
            HTMLwasSelected = false
      }

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      hide: { start: (detail) => { fullcontEntity.hide(detail, htmlFc) } },
      prepareEdit: { start: (detail) => { fullcontHandler.prepareEdit(detail, htmlFc) } },
      prepareView: { start: (detail) => { fullcontHandler.prepareView(detail, htmlFc) } },
      selectOne: { start: (detail) => { selectOne(detail, htmlFc) } },
      showMtlost: { start: (detail) => { handler.showMtlost(htmlFc) } },
      fullcontOptions: { start: (detail) => { clientPurchaseMenu.start(detail, 'htmlDt', htmlFc) } },

      pdfMenuFullcont: { start: (detail) => { pdfMenuFullcont(detail, htmlFc) } },

}/**/

export function pdfMenuFullcont(detail, htmlFc) {
      const fullcont = htmlFc.fullcontHTML ?? null;
      const dbid = fullcont.getAttribute("data-dbid") ?? detail.dbid;
      printReport(dbid, detail.entity, detail.reportName);
}

function printReport(dbid, entity, reportName) {
      const formData = new FormData();
      formData.append('id', dbid);
      formData.append('type', 'print');
      formData.append('entity', entity);
      formData.append('reportName', reportName);

      const isPdf = true;

      const controller = new AbortController();
      const timeout = setTimeout(() => { controller.abort() }, 30000);

      let options = {
            method: 'POST',
            body: formData,
            signal: controller.signal,
            credentials: 'same-origin'
      };

      fetch(`./server/php/report/report-pdf.php`, options)
            .then((response) => {
                  clearTimeout(timeout);
                  if (!response.ok) throw new Error("report-pdf");
                  // 1. Cambiamos .text() por .blob() para manejar el binario del PDF correctamente

                  return response.blob();
            })
            .then((blob) => {
                  if (isPdf) {
                        // --- LÓGICA PARA PDF ---
                        const pdfBlob = new Blob([blob], { type: "application/pdf" });
                        const fileUrl = URL.createObjectURL(pdfBlob);
                        const newTab = window.open(fileUrl, "_blank");

                        if (newTab) {
                              newTab.addEventListener('load', () => {
                                    URL.revokeObjectURL(fileUrl);
                              }, { once: true });
                        }
                  } else {
                        // --- LÓGICA PARA CSV ---
                        // Se define el MIME type para CSV
                        const csvBlob = new Blob([blob], { type: "text/csv;charset=utf-8;" });
                        const fileUrl = URL.createObjectURL(csvBlob);

                        // Creamos un enlace temporal en el DOM
                        const tempLink = document.createElement("a");
                        tempLink.href = fileUrl;

                        // Asignamos un nombre de archivo por defecto (puedes personalizarlo)
                        tempLink.setAttribute("download", `report_${new Date().getTime()}.csv`);
                        tempLink.style.display = "none";

                        document.body.appendChild(tempLink);
                        tempLink.click(); // Disparamos la descarga

                        // Limpiamos el DOM y liberamos la memoria
                        document.body.removeChild(tempLink);
                        URL.revokeObjectURL(fileUrl);
                  }
            })

            .catch(error => {
                  throw error;
            });
}

function selectOne(detail, htmlFc) {
      const entityFc = document.querySelector('#clientPurchase-fullcont');

      if (entityFc) {
            if (entityFc.classList.contains('fullcont-show')) {
                  entityFc.classList.remove('fullcont-show');
                  fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne);
                  return;
            }
      }

      fullcontEntity.selectOne(detail, htmlFc, processAfterSelectOne);
}/**/

function processAfterSelectOne(data, result) {
      handler.showLost();
}

//function to send
function editDialog() {
      dialog.start({ act: "show", id: "saveChanges", entity: 'clientPurchase' })
}

function deleteDialog(detail) {
      dialog.start({ act: "show", dest: 'clientPurchase', id: "deleteElem", entity: 'clientPurchase', dbid: detail.dbid })
}

function dtCall(act, result) {
      clientPurchaseDt.start({ act: act, row: result })
}